/*jshint esversion:6 */
import React from "react";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import Select from "react-select";
import Util from "../../../util/util";
import Permissions from "../../../configurations/permissions";
import { FaBan, FaRedo } from "react-icons/fa";


class SelectDropdown extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
        loading: false
    };
  }
  setLoadingFalse = () => this.setState({ loading: false})
  reload = () => {
    this.setState({ loading: true}, () => {
        this.props.loadOptions(this.setLoadingFalse)
    })
}
componentDidMount() {
    this.reload();
}

  render() {
    const { name, placeholder, value, options, onChange, loadOptions, disabled } = this.props;
    const { loading } = this.state;
    return (
        <div className="disputesSelect">
            <div className="deselect">
                <Select
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    loadingMessage="loading"
                    options={options}
                    onChange={onChange}
                    disabled={disabled}
                    className="select-drop"
                />     
            </div>
            
            
            {   loadOptions ?
                <div className="deselect_action">
                    {  loading ?
                        <span className="disputesSelect-span">
                            <FaBan />
                        </span> :
                        <span onClick={this.reload} className="disputesSelect-span">
                            <FaRedo />
                        </span> 
                    }
                </div> : ""
            } 
        </div>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(SelectDropdown, [Permissions.VIEW_DISPUTE])
);



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/DisputeSelectDropdown.js